import { useState } from 'react';
import { useDatos } from '../../datos/DatosContext';
import { useAviso } from '../../lib/avisos';
import { Icono } from '../../componentes/ui/Icono';
import { Demo, GrupoChips, Volver } from '../../componentes/ui/basicos';
import { NoEncontrado } from '../NoEncontrado';

export function ActividadDetalle({ id }: { id: string }) {
  const { datos, actualizar } = useDatos();
  const aviso = useAviso();
  const actividad = datos.actividades.find((c) => c.id === id);
  const [borrador, setBorrador] = useState(actividad?.respuesta ?? '');
  if (!actividad) return <NoEncontrado />;

  const guardar = () => {
    const estado = actividad.estado === 'Pendiente' && borrador.trim() ? 'En curso' : actividad.estado;
    actualizar('actividades', actividad.id, { respuesta: borrador, estado });
    aviso('Respuesta guardada (solo en esta sesión).');
  };

  return (
    <div className="stack-lg">
      <Volver a="/cursos">Cursos y ejercicios</Volver>
      <header>
        <p className="eyebrow">{actividad.curso} · {actividad.tipo}</p>
        <h1 className="display">{actividad.titulo}</h1>
      </header>
      <section className="card soft stack-sm">
        <h2 className="eyebrow">Instrucciones</h2>
        <p className="prose" style={{ margin: 0 }}>{actividad.instrucciones}</p>
        <div>
          <button className="btn quiet small" onClick={() => aviso('Solo visual: aquí se abrirá el material o el enlace del curso.')}>
            <Icono nombre="link" tam="sm" />Abrir material <Demo />
          </button>
        </div>
      </section>
      <section className="card stack-sm">
        <label className="eyebrow" htmlFor="resp">Mi respuesta</label>
        <textarea id="resp" rows={6} placeholder="Escribe a tu ritmo. Puedes volver cuando quieras." value={borrador} onChange={(e) => setBorrador(e.target.value)} />
        <p className="small muted" style={{ margin: 0 }}>Tu respuesta es tuya: ninguna respuesta de IA la sustituye.</p>
        <div className="row" style={{ justifyContent: 'flex-end' }}><button className="btn primary" onClick={guardar}>Guardar respuesta</button></div>
      </section>
      <section className="stack-sm">
        <span className="lbl">Estado</span>
        <GrupoChips etiqueta="Estado de la actividad" opciones={datos.opciones.estadosActividad} seleccion={actividad.estado}
          onElegir={(e) => actualizar('actividades', actividad.id, { estado: e })} />
      </section>
    </div>
  );
}
